import React, {useState, useEffect, useRef} from "react";
import './App.css'
import Canvas from "./Canvas"; // Change the path according to the directory structure of your project
const width = 1500
const height = width/2

function CoordinateDisplay({title, x, y}) {
  const X_deg = (x/width)*360-180
  const Y_deg = -1*((y/height)*180-90)
  const X_letter = X_deg<=0 ? 'W' : 'E'
  const Y_letter = Y_deg<=0 ? 'S' : 'N'
  function calcMin(deg) {
    return(
      (deg-Math.trunc(deg))*60
    )
  }
  function calcSecs(deg) {
    return(
      (calcMin(deg)-Math.trunc(calcMin(deg)))*60
    )
  }

  return (
    <>
    <div className='Data-display'>
      <p><b>{title}:</b>&nbsp;</p>
      <p>{Math.trunc(Math.abs(Y_deg))}&deg;{Y_letter}&#8239;
      {Math.trunc(calcMin(Math.abs(Y_deg)))}&prime;&#8239;
      {Math.trunc(calcSecs(Math.abs(Y_deg)))}&Prime;&nbsp;</p>

      <p>{Math.trunc(Math.abs(X_deg))}&deg;{X_letter}&#8239;
      {Math.trunc(calcMin(Math.abs(X_deg)))}&prime;&#8239;
      {Math.trunc(calcSecs(Math.abs(X_deg)))}&Prime;</p>
    </div>
    </>
  )
}

function DistanceDisplay({start_x, start_y, stop_x, stop_y}) {
  function deg2rad(deg) {
    return (deg*(Math.PI/180))
  }
  const start_x_rad = deg2rad((start_x/width)*360-180)
  const start_y_rad = deg2rad(-1*((start_y/height)*180-90))
  const stop_x_rad = deg2rad((stop_x/width)*360-180)
  const stop_y_rad = deg2rad(-1*((stop_y/height)*180-90))
  const a = Math.sin(start_y_rad)*Math.sin(stop_y_rad)
  const b = Math.cos(start_y_rad)*Math.cos(stop_y_rad)
  const c = Math.cos(Math.abs(start_x_rad-stop_x_rad))
  const distance = Math.acos(a+b*c)*4510.039;
  return (
    <>
    <div className='Data-display'>
      <p><b>Distance:</b>&nbsp;</p>
      <p>{distance.toFixed(0)} km</p>
    </div>
    </>
  )


}

function App() {
  const [drawing, setDrawing] = useState({start: 0, stop: 0})
  const [startLoc, setStartLoc] = useState([0, 0])
  const [stopLoc, setStopLoc] = useState([0, 0])
  const [divBox, setDivBox] = useState([0, 0])
  const divRef = useRef(null)

   const draw = (cvs) => {
    const ctx = cvs.getContext('2d')
    const bounding = cvs.getBoundingClientRect();
    //console.log(bounding)
    //ctx.clearRect(0,0,ctx.canvas.width, ctx.canvas.height)
    const img = new Image()
    img.onload = () => {
      ctx.drawImage(img, 0,0,width, height)
      if (drawing.start == 1 || drawing.stop == 1) {
        const start = {x: startLoc[0]-bounding.x, y: startLoc[1]-bounding.y}
        const stop = {x: stopLoc[0]-bounding.x, y: stopLoc[1]-bounding.y}
        const text_offset = 10;
        ctx.beginPath()
        ctx.moveTo(start.x, start.y)
        ctx.lineTo(stop.x, stop.y)
        ctx.lineWidth = 2
        ctx.strokeStyle = '#707070'
        ctx.lineCap = 'round'
        ctx.stroke()
      }
    }
    img.src = "https://wiki.statesmanship.co.uk/images/7/74/SMS_Worldmap.png"
  }

  function divClickHandler(e) {
    const {x: divX, y: divY} = divRef.current.getBoundingClientRect();
    setDivBox([divX, divY])
    console.log({divX, divY})
    console.log(startLoc[0]-divBox[0])
    if (drawing.start == 0) {
      setDrawing({start: 1, stop: 0})
      setStartLoc([e.clientX, e.clientY])
      //console.log(startLoc)
      }

    else {
      setDrawing({start: 0, stop: 1})
      setStopLoc([e.clientX, e.clientY])
      //console.log(stopLoc)
    }
  }

  function divMoveHandler(e) {
    if (drawing.start == 1 && drawing.stop == 0){
      setStopLoc([e.clientX, e.clientY])
      //console.log(stopLoc)
    }
  }
  
  return (
    <div className="App">
    <h1 className="App-header">SMS Great Circle Distance Calculator</h1>
    <div className='Interactive' ref={divRef} onClick={divClickHandler} onMouseMove={divMoveHandler}>
      <Canvas draw={draw} height={height} width={width}/>
    </div>
    <div className='Coordinate-display'>
      <CoordinateDisplay title="Start" x={startLoc[0]-divBox[0]} y={startLoc[1]-divBox[1]}/>
      <CoordinateDisplay title="Stop" x={stopLoc[0]-divBox[0]} y={stopLoc[1]-divBox[1]}/>
      <DistanceDisplay start_x={startLoc[0]-divBox[0]} start_y={startLoc[1]-divBox[1]} stop_x={stopLoc[0]-divBox[0]} stop_y={stopLoc[1]-divBox[1]}/>
    </div>
    </div>
  )
}

export default App;
